import React from 'react';

import { IArticleInsight, ArticlesAndInsights } from './ArticleInsights';

import './Articles.scss';

export interface LeadershipArticlesInputs {
    id?: string;
    header?: string;
    articles?: IArticleInsight[];
}
export const Articles = ({ inputs }: { inputs: LeadershipArticlesInputs }) => {
    if (!inputs) return;
    return (
        <section className="leadership-articles">
            <h3 className="leadership-articles__heading">{inputs.header}</h3>
            <ul className="leadership-articles__article-list">
                {inputs.articles.map((article) => (
                    <ArticlesAndInsights key={article.id} article={article} />
                ))}
            </ul>
        </section>
    );
};
